import { createContext, useContext, useEffect, useState } from "react";
import TokenManager from "../client/js/utils/storage/TokenManager";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [isAuth, setIsAuth] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            const token = await TokenManager.getAccessToken();
            setIsAuth(!!token);
            setLoading(false);
        })();
    }, []);

    const login = async (tokens) => {
        await TokenManager.saveTokens(tokens);
        setIsAuth(true);
    };

    const logout = async () => {
        await TokenManager.removeTokens();
        setIsAuth(false);
    };

    return (
        <AuthContext.Provider value={{ isAuth, loading, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
